import { render, staticRenderFns } from "./wdorder.vue?vue&type=template&id=ee493086&scoped=true&"
import script from "./wdorder.vue?vue&type=script&lang=js&"
export * from "./wdorder.vue?vue&type=script&lang=js&"
import style0 from "./wdorder.vue?vue&type=style&index=0&id=ee493086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee493086",
  null
  
)

export default component.exports